export default __webpack_public_path__ + "static/media/placeholder-box@2x.f22149c2.png";